'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
require('./Heading.js');
var react = require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Heading - h4
 *
 * @see Docs https://chakra-ui.com/heading
 */
var HeadingH4 = function HeadingH4(props) {
  return /*#__PURE__*/React__default["default"].createElement(react.Heading, _extends__default["default"]({
    as: "h4",
    size: "h4"
  }, props));
};
HeadingH4.displayName = 'HeadingH4';
exports.HeadingH4 = HeadingH4;